/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  defaultMapMarker,
  imgElementSvg,
} from '../../../components/shared/vector-images';
import { getStore } from '../../store';
import {
  layerExists,
  setDataSource,
  sourceExists,
  toggleLayerIfRequired,
} from '../_helpers';

let mapReference: any;

// eslint-disable-next-line no-unused-vars
let selectedListingId: string | undefined | null;
const layerName = 'marketplaceListings';

const loadDefaultImageIntoMap = async () => {
  if (!mapReference.hasImage('defaultMapMarker')) {
    const marker = await imgElementSvg(defaultMapMarker(), {
      width: 100,
      height: 100,
    });
    mapReference.addImage('defaultMapMarker', marker);
  }
};

export const updateDataSource = (data: { [key: string]: unknown }[]): void => {
  const defaultIcon = 'defaultMapMarker';
  const geojson = {
    type: 'FeatureCollection',
    features: data.map((item) => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [item.longitude, item.latitude],
      },
      properties: {
        ...item,
        image: item.image || defaultIcon,
        markerSelected: selectedListingId === item.id,
      },
    })),
  };

  setDataSource(mapReference, layerName, geojson);
};

const addLayersIfRequired = () => {
  if (!mapReference) return;

  if (!sourceExists(mapReference, layerName)) {
    mapReference.addSource(layerName, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: [],
      },
    });
  }

  if (!layerExists(mapReference, layerName)) {
    mapReference.addLayer({
      id: layerName,
      type: 'symbol',
      source: layerName,
      layout: {
        'icon-image': ['to-string', ['get', 'image']],
        'icon-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          2.9999,
          ['case', ['==', ['get', 'markerSelected'], true], 0.6, 0],
          3,
          ['case', ['==', ['get', 'markerSelected'], true], 0.6, 0.4],
          8.5,
          ['case', ['==', ['get', 'markerSelected'], true], 0.6, 0.4],
          11,
          ['case', ['==', ['get', 'markerSelected'], true], 0.6, 0.4],
          14,
          ['case', ['==', ['get', 'markerSelected'], true], 0.6, 0.4],
        ],
        'icon-anchor': 'bottom',
        'icon-allow-overlap': true,
        'text-allow-overlap': true,
      },
      paint: {},
    });
  }
};

const layer: { [key: string]: unknown } = {
  displayName: 'Marketplace listings',
  synonyms: '',
  group: '',
  typeUrl: '',
  icon: {
    baseShape: defaultMapMarker,
    iconColor: '#fff',
    markerColor: '#139ECA',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: false,
    owningMenu: 'marine-points-of-interest',
    order: 5,
  },
};

layer.onInitialize = (map: any) => {
  // eslint-disable-next-line no-multi-assign
  mapReference = map;
  addLayersIfRequired();

  map.on('deckee-press', layerName, async (event: any) => {
    // This is to select a marker and go to the popover
    const { id } = event.features[0].properties;

    selectedListingId = id;
    // transitionToRawURL(`/maps/signal/${id}`);
    event.originalEvent.preventDefault();
  });

  getStore().subscribe(() => {
    const state = getStore().getState();
    const listingId = state.marketplace.selectedListing;
    const listing = state.marketplace.listings[listingId || ''];

    const selectedId = listing && listing.id;
    if (selectedId !== selectedListingId) {
      selectedListingId = selectedId;
      if (!listing) {
        updateDataSource([]);
      } else if (!listing.isMarker) {
        loadDefaultImageIntoMap();
        updateDataSource([
          {
            latitude: listing.location.latitude,
            longitude: listing.location.longitude,
          },
        ]);
      }
    }
  });
};

layer.onToggle = (map: any, show: boolean) => {
  toggleLayerIfRequired(map, layerName, show);
};

export default layer;
